import { render } from "./PatientCoreFields.vue?vue&type=template&id=5f56fe3b"
import script from "./PatientCoreFields.vue?vue&type=script&lang=js"
export * from "./PatientCoreFields.vue?vue&type=script&lang=js"

import "./PatientCoreFields.vue?vue&type=style&index=0&id=5f56fe3b&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__